// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"62":"f09c7d68","535":"195cdcce","945":"ffcef6b1"}[chunkId] + ".css";
};